import React, { Component } from "react";
import s from "./index.module.scss";
import classNames from "classnames/bind";

var cx = classNames.bind(s);

export default class DataPreloader extends Component {
  componentDidMount() {
    this.props.action();
  }

  render() {
    const { loading, children } = this.props;
    const Loader = this.props.loader;

    return (
      <>
        {loading && Loader && <Loader />}
        <div className={cx(["mask"], { loaded: !loading })}>
          {!loading && children}
        </div>
      </>
    );
  }
}
